<a routerLink="/" class="inline-flex h-16 p-(--padding-card) justify-center items-center text-xl font-bold cursor-pointer select-none">
  <span class="uppercase text-(color:--text-primary)">{{ highlightedPart }}</span
  ><span class="text-orange-100">{{ remainingPart }}</span>
  <span class="flex flex-col justify-between items-start h-full">
    @if (!!environment.name && environment.name !== 'prod') {
      <span class="font-normal text-xs text-(color:--text-secondary) block leading-none">({{ environment.name }})</span>
    }
    @if (t.testMode()) {
      <span class="font-normal text-xs text-(color:--text-secondary) block leading-none">{{ 'navigation.testMode' | transloco }}</span>
    }
  </span>
</a>
